// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "0.0.25/static/js/" + chunkId + "." + "a306ab47" + ".chunk.js";
};